<template>
  <div class="wrapper fora" v-if="membro">
    <CabecalhoPdf ref="cabecalhoPdf" />
    <div class="topo-header centro so-tela">
      <div style="display: flex; align-items: center;">
        <botao-voltar class="voltar" nomeRota="Membros" />
        <h1>Visualizar Membro</h1>
      </div>
      <div class="acoes-topo">        
        <!-- Botão Novo Membro agora usa a classe padronizada btn-novo -->
        <router-link :to="{ name: 'MembroNew' }" class="btn-acao btn-novo" title="Novo Membro">
          + Novo Membro
        </router-link>
        
        <router-link :to="{ name: 'MembroEdit', params: { id: membro.id } }">
          <button class="btn-acao btn-editar" title="Editar">Editar</button>
        </router-link>
        
        <button class="btn-acao btn-excluir" title="Excluir" @click.prevent="modalExclusaoVisivel = true">Excluir</button>

        <button class="btn-baixar-pdf" @click="exportToPdf()">
          Baixar PDF
        </button>
      </div>

    </div>
    
    <div ref="pdfMembro" class="form centro pdf-membro">
      <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
      <div class="conteudo-cards">
        
        <!-- GRADE 1: DADOS BÁSICOS (Tudo na mesma linha) -->
        <div class="painel-dados so-tela" style="margin-bottom: 1.5rem;">
          <div class="secao-dados">
            <h2 class="secao-titulo">Informações Gerais</h2>
            <div class="grade-dados">
              
              <!-- CPF (1/4 da linha) -->
              <div class="item-dado">
                <span class="item-rotulo">CPF</span>
                <span class="item-valor">{{ formatarCPF(membro.cpf) }}</span>                    
              </div>
              
              <!-- NOME (Ocupa espaço maior: 2/4 da linha) -->
              <div class="item-dado item-dado--span2">
                <span class="item-rotulo">Nome</span>
                <span class="item-valor">{{ formatarNomeProprio(membro.nome) }}</span>                    
              </div>
              
              <!-- SERVIDOR PÚBLICO (1/4 da linha) -->
              <div class="item-dado">
                <span class="item-rotulo">Servidor Público</span>
                <span class="item-valor">{{ membro.servidor_publico ? 'Sim' : 'Não' }}</span>
              </div>

            </div>
          </div>
        </div>

        <!-- DADOS BÁSICOS PARA O PDF -->
        <div class="dados dados-membro so-pdf" style="margin-bottom: 14px;">
          <fieldset style="border: 1px solid #005516 !important; border-radius: 12px !important; padding: 16px 20px !important; background-color: #ffffff !important;">
            <div class="dados">
              <div class="flexbox-1">
                <p style="color: #005516; font-size: 8pt; font-weight: bold; text-transform: uppercase;">
                  <strong>CPF:</strong>
                  <span style="color: #1f2937; font-size: 10pt; font-weight: normal; text-transform: none; margin-left: 4px;">{{ formatarCPF(membro.cpf) }}</span>
                </p>
                <p style="color: #005516; font-size: 8pt; font-weight: bold; text-transform: uppercase;">
                  NOME:
                  <span style="color: #1f2937; font-size: 10pt; font-weight: normal; text-transform: none; margin-left: 4px;">{{ formatarNomeProprio(membro.nome) }}</span>
                </p>
                <p style="color: #005516; font-size: 8pt; font-weight: bold; text-transform: uppercase;">
                  <strong>SERVIDOR PÚBLICO:</strong>
                  <span style="color: #1f2937; font-size: 10pt; font-weight: normal; text-transform: none; margin-left: 4px;">{{ membro.servidor_publico ? 'Sim' : 'Não' }}</span>
                </p>
              </div>
            </div>
          </fieldset>
        </div>

        <div class="filtro-container so-tela">
          <span class="filtro-label">Filtro por status:</span>
          <button class="btn-filtro" :class="{ ativo: filtroStatus === 'Todos' }" @click="filtroStatus = 'Todos'">Todos</button>
          <button class="btn-filtro" :class="{ ativo: filtroStatus === 'Vigente' }" @click="filtroStatus = 'Vigente'">Vigente</button>
          <button class="btn-filtro" :class="{ ativo: filtroStatus === 'Encerrado' }" @click="filtroStatus = 'Encerrado'">Encerrado</button>
        </div>

        <!-- GRADE 2: HISTÓRICO DE PARTICIPAÇÃO -->
        <div class="painel-dados">
          <div class="secao-dados">
            <h2 class="secao-titulo so-tela">Histórico de Participação em Colegiados</h2>
            
            <p v-if="carregandoHistorico" class="texto-aviso so-tela">Buscando histórico...</p>
            
            <div v-else-if="historicoFiltrado.length > 0">
              <div class="historico-cards so-tela">
                <div v-for="(item) in historicoFiltrado" :key="item.id" class="cartao-historico">
                  <div class="grade-dados grade-dados-historico">
                    <div class="item-dado">
                      <span class="item-rotulo">Órgão</span>
                      <span class="item-valor">{{ formatarNomeProprio(item.orgao_nome) || '-' }}</span>
                    </div>
                    <div class="item-dado">
                      <span class="item-rotulo">Colegiado</span>
                      <span class="item-valor">
                        <span v-if="item.colegiado_sigla" class="sigla-destaque">{{ item.colegiado_sigla.toUpperCase() }} - </span>
                        {{ formatarNomeProprio(item.colegiado_nome) }}
                      </span>
                    </div>

                    <div class="item-dado">
                      <span class="item-rotulo">Cargo / Função</span>
                      <span class="item-valor">
                        <span v-if="item.cargo">{{ formatarNomeProprio(item.cargo) }}</span>
                        <span v-if="item.cargo && item.funcao"> / </span>
                        <span v-if="item.funcao">{{ formatarNomeProprio(item.funcao) }}</span>
                        <span v-if="!item.cargo && !item.funcao">-</span>
                      </span>
                    </div>

                    <div class="item-dado">
                      <span class="item-rotulo">Tipo de Mandato</span>
                      <span class="item-valor">{{ formatarTextoMaiusculas(item.tipo_mandato_nome) }}</span>
                    </div>
                    <div class="item-dado">
                      <span class="item-rotulo">Status do Mandato</span>
                      <span class="item-valor">{{ formatarTextoMaiusculas(item.status_mandato || '-') }}</span>
                    </div>
                    <div class="item-dado">
                      <span class="item-rotulo">Período</span>
                      <span class="item-valor">{{ formatarDataHora(item.data_inicio) }} a {{ item.data_termino ? formatarDataHora(item.data_termino) : 'Atualmente' }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- HISTÓRICO DO MEMBRO PARA O PDF -->
              <table class="table pdf-table-planilha tabela-historico so-pdf">
                <thead>
                  <tr>
                    <th class="pdf-index-col-head">Nº</th>
                    <th>Órgão</th>
                    <th>Colegiado</th>
                    <th>Cargo / Função</th>
                    <th>Status do Mandato</th>
                    <th>Tipo de Mandato</th>
                    <th>Período</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, idx) in historicoFiltrado" :key="'pdf-' + item.id">
                    <td class="pdf-index-col-cell">{{ idx + 1 }}</td>
                    <td>
                      <span v-if="item.orgao_nome">{{ formatarNomeProprio(item.orgao_nome) }}</span>
                      <span v-if="item.orgao_sigla"> – {{ item.orgao_sigla.toUpperCase() }}</span>
                    </td>
                    <td>
                      <span> {{ formatarNomeProprio(item.colegiado_nome) }}</span>
                      <span v-if="item.colegiado_sigla" class="sigla-destaque">
                        – {{ item.colegiado_sigla.toUpperCase() }}
                      </span>
                    </td>
                    <td>
                      <span v-if="item.cargo">
                        {{ formatarNomeProprio(item.cargo) }}
                      </span>
                      <br v-if="item.cargo && item.funcao">
                      <small v-if="item.funcao" class="funcao-destaque">
                        {{ formatarNomeProprio(item.funcao) }}
                      </small>
                    </td>
                    <td class="coluna-status-mandato">
                      {{ formatarTextoMaiusculas(item.status_mandato || '-' )}}
                    </td>
                    <td class="coluna-tipo-mandato">
                      {{ formatarTextoMaiusculas(item.tipo_mandato || '-') }}
                    </td>
                    <td class="coluna-periodo">
                      {{ formatarDataHora(item.data_inicio) }} a
                      {{ item.data_termino ? formatarDataHora(item.data_termino) : 'Atualmente' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <p v-else class="texto-aviso so-tela">Nenhum histórico de mandatos encontrado para este membro.</p>
          </div>
        </div>

      </div>
    </div>
    
    <!-- MODAL DE EXCLUSÃO  -->
    <div v-if="modalExclusaoVisivel" class="modal-exclusao">
      <div class="modal-mask">
        <div class="modal-container">
          <div class="modal-header">
            <h2>Deseja mesmo excluir este Membro?</h2>
          </div>
          <div class="modal-body">
            <p>Dados Básicos do Membro:</p>
            <div class="dados">
              <div class="flexbox">
                <div class="texto-centralizado">
                  CPF: <span>{{ formatarCPF(membro.cpf) }}</span>
                </div>
                <div class="texto-centralizado">
                  Nome: <span>{{ formatarNomeProprio(membro.nome) }}</span>
                </div>
                <div class="texto-centralizado">
                  Servidor Público: <span>{{ membro.servidor_publico ? 'Sim' : 'Não' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn-confirmar-exclusao" @click="confirmarExclusao">Sim</button>
            <button class="btn-cancelar-exclusao" @click="modalExclusaoVisivel = false">Não</button>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================================= -->

    <div>
      <Footer
        :createdByLabel="'Criado por'"
        :criadoPor="membro.criado_por"
        :lastUpdatedByLabel="'Última atualização feita por'"
        :atualizadoPor="membro.atualizado_por"
        :emLabel="' em '"
        :SistemaLabel="'Sistema'"
        :created_at="membro.created_at"
        :updated_at="membro.updated_at"
      />
    </div>
  </div>
</template>

<script>
import BotaoVoltar from "../BotaoVoltar.vue";
import MembroApi from "../../services/MembroApi";
import { parseISO, format } from "date-fns";
import Footer from "../Footer.vue";
import html2pdf from 'html2pdf.js';
import MsgErroFormularios from "../MsgErroFormularios";
import CabecalhoPdf from '../pdf_components/Cabecalho.vue';
import html2canvas from 'html2canvas';

export default {
  name: "ExibirMembros",
  props: {
    membro: Object,
  },
  data() {
    return {
      modalExclusaoVisivel: false,
      carregandoHistorico: false,
      historico: [],
      filtroStatus: 'Vigente',
      erro: false,
      msgErros: null,
    };
  },
  computed: {
    historicoFiltrado() {
      if (!this.historico) return [];
      if (this.filtroStatus === 'Todos') return this.historico;

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      
      return this.historico.filter(item => {
        const statusMandato = String(item.status_mandato || '').trim().toLowerCase();
        if (statusMandato === 'vigente' || statusMandato === 'encerrado') {
          return statusMandato === this.filtroStatus.toLowerCase();
        }

        let statusAtual = 'Vigente'; // Assume vigente por padrão (especialmente se data_termino for nula)

        if (item.data_termino) {
          const dataTermino = parseISO(item.data_termino);
          dataTermino.setHours(0, 0, 0, 0);

          if (dataTermino < hoje) {
             statusAtual = 'Encerrado';
          }
        }

        if (this.filtroStatus === 'Vigente') {
          return statusAtual === 'Vigente';
        } else if (this.filtroStatus === 'Encerrado') {
          return statusAtual === 'Encerrado';
        }
        
        return true;
      });
    }
  },
  mounted() {
    if (this.membro && this.membro.id) {
      this.buscarHistorico();
    }
  },
  created() {
    this.MembroApi = new MembroApi();
    this.MandatosApi = new (require('../../services/MandatosApi').default)();
  },
  components: {
    BotaoVoltar,
    Footer,
    MsgErroFormularios,
    CabecalhoPdf,
  },
  watch: {    
    'membro.id': function(novoId) {
      if (novoId) {
        this.buscarHistorico();
      }
    }
  },
  methods: {
    async confirmarExclusao() {
      try {
        if (!this.MembroApi) this.MembroApi = new MembroApi();
        if (this.MembroApi.cancelTokens && this.MembroApi.cancelTokens.destroyMembro) {
          this.MembroApi.cancelTokens.destroyMembro.cancel();
        }
        await this.MembroApi.destroyMembro(this.membro.id);
        this.$router.push({ name: "Membros" }); 
      } catch (err) {
        if (this.MembroApi.isCancel && this.MembroApi.isCancel(err)) return;
        
        this.modalExclusaoVisivel = false;
        this.erro = true;
        
        // Forçamos a mensagem amigável em vez de aceitar o "Internal Server Error" do backend
        this.msgErros = {
           membro: "Não foi possível excluir o membro, pois ele está associado a um mandato."
        };
        
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },    
    fecharErro() {
      this.erro = false;
      this.msgErros = null;
    },
    async buscarHistorico() {
      this.carregandoHistorico = true;
      this.historico = []; 

      try {
        // 1. Busca o histórico básico do membro
        const dadosHistorico = await this.MembroApi.getHistoricoMembro(this.membro.id);

        // 2. Busca o detalhe de cada mandato individualmente
        const promessasMandatos = dadosHistorico.map(item => 
          this.MandatosApi.getMandato(item.id)
            .then(res => res?.mandato || res)
            .catch(() => null)
        );

        const mandatosDetalhadados = await Promise.all(promessasMandatos);

        // 3. Mescla os status resolvidos de volta na tabela do histórico
        this.historico = dadosHistorico.map((itemHistorico, index) => {
          const mandatoDetalhado = mandatosDetalhadados[index];

          return {
            ...itemHistorico,
            // Recupera o status_mandato do mandato resolvido pela API
            status_mandato: mandatoDetalhado ? (mandatoDetalhado.status_mandato || mandatoDetalhado.status || '-') : '-',
            tipo_mandato: itemHistorico.tipo_mandato_nome || (mandatoDetalhado ? mandatoDetalhado.tipo_mandato : '-')
          };
        });

      } catch (erro) {
        console.error("Erro ao carregar histórico detalhado do membro:", erro);
        alert("Não foi possível carregar o histórico no momento.");
      } finally {
        this.carregandoHistorico = false;
      }
    },

    formatarNomeProprio(texto) {
        if (!texto) return '';
        
        const excecoesMinusculas = ['de', 'da', 'do', 'das', 'dos', 'e', 'no', 'na'];
        const siglasConhecidas = [
          'AGR', 'ALEGO', 'SANEAGO', 'DETRAN', 'SGU', 'SISCOL', 'GOINFRA', 
          'CPF', 'RG', 'GO', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
        ];
        
        return texto
          .toString()
          .toLowerCase()
          .split(' ')
          .map(palavra => {
            const palavraLimpa = palavra.replace(/[()]/g, '').toUpperCase();
  
            if (siglasConhecidas.includes(palavraLimpa)) {
              return palavra.toUpperCase();
            }
  
            if (excecoesMinusculas.includes(palavra)) {
              return palavra;
            }
  
            return palavra.charAt(0).toUpperCase() + palavra.slice(1);
          })
          .join(' ');
      },
    formatarDataHora: function (value) {
      if (!value) return '-';
      return format(parseISO(value), "dd/MM/yyyy");
    },
    formatarCPF(cpf) {
      if (!cpf) return '';
      cpf = cpf.replace(/\D/g, '');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      return cpf;
    },
    formatarTextoMaiusculas(value) {
      if (!value) return ''
      const preposicoes = ['a', 'de', 'da', 'do', 'das', 'dos', 'e', 'com', 'em', 'no', 'na', 'nos', 'nas', 'para', 'por', 'di']
      return value
        .toLowerCase()
        .split(' ')
        .map((palavra, index) => {
          if (preposicoes.includes(palavra) && index !== 0) {
            return palavra
          }
          return palavra.charAt(0).toUpperCase() + palavra.slice(1)
        })
        .join(' ')
    },

    async exportToPdf() {
      const container = this.$refs.pdfMembro
      if (!container) {
        alert('Dados do membro não encontrados para exportação.')
        return
      }

      const style = document.createElement('style')
      style.id = 'pdf-membro-print-styles'
      style.textContent = `
          .pdf-membro .so-tela,
          .pdf-membro .so-tela * {
            display: none !important;
          }
          .pdf-membro table.tabela-historico.so-pdf {
            display: table !important;
          }
          .pdf-membro .dados-membro.so-pdf {
            display: block !important;
          }

          .pdf-index-col-head,
          .pdf-index-col-cell {
            width: 44px !important;
            min-width: 44px !important;
            max-width: 44px !important;
            padding-left: 4px !important;
            padding-right: 4px !important;
            text-align: center !important;
          }

          .tituloTabela {
          display: none !important;
          }

          .pdf-membro.form.centro {
            width: 267mm !important;
            max-width: 267mm !important;
            box-sizing: border-box !important;
            padding: 0 !important;
            margin: 0 auto !important;
            overflow: visible !important;
            background-color: #ffffff !important;
            color: #1f2937 !important;
            font-family: Arial, sans-serif !important;
          }

          .pdf-membro .conteudo-cards {
            width: 100% !important;
            margin-top: 0 !important;
          }

          .pdf-membro .painel-dados,
          .pdf-membro .secao-dados {
            display: block !important;
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
          }

          .pdf-membro .dados-membro > fieldset {
            box-sizing: border-box !important;
            width: 100% !important;
            margin: 0 0 14px 0 !important;
            padding: 16px 20px !important;
            border: 1px solid #005516 !important;
            border-radius: 12px !important;
            background-color: #ffffff !important;
            box-shadow: 0 2px 6px rgba(0, 85, 22, 0.14) !important;
          }

          .pdf-membro .dados-membro .dados {
            width: 100% !important;
            margin: 0 !important;
          }

          .pdf-membro > .dados-historico > fieldset {
            border-radius: 0 !important;
            border: none !important;
            box-shadow: none !important;
            padding: 0 !important;
          }

          .pdf-membro .tabela-historico {
            margin: 0 !important;
            width: 100% !important;
          }

          .pdf-membro .dados-membro .flexbox-1 {
            display: grid !important;
            grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
            width: 100% !important;
            column-gap: 16px !important;
            row-gap: 12px !important;
            justify-content: center !important;
            align-items: center !important;
          }

          .pdf-membro .dados-membro p {
            display: flex !important;
            flex-direction: column !important;
            justify-content: center !important;
            align-items: center !important;
            text-align: center !important;
            overflow-wrap: anywhere !important;
            gap: 4px !important;
            margin: 0 !important;
            color: #005516 !important;
            font-size: 8pt !important;
            font-weight: bold !important;
            text-transform: uppercase !important;
          }

          .pdf-membro .dados-membro p span {
            margin: 0 !important;
            color: #1f2937 !important;
            font-size: 10pt !important;
            font-weight: normal !important;
            text-transform: none !important;
          }

          .pdf-membro .dados-membro p strong {
            font-weight: bold !important;
          }

          .pdf-membro .dados2 {
            font-family: Arial, sans-serif !important;
          }

          .pdf-membro .dados2 h2 {
            margin: 0 0 12px 0 !important;
            color: #005516 !important;
            font-size: 12pt !important;
            font-weight: bold !important;
          }

          .bt-editar {
            display: none !important;
          }

          .tabela-historico {
            box-sizing: border-box !important;
            width: 100% !important;
            border-collapse: collapse !important;
            table-layout: fixed !important;
            margin: 0 !important;
            page-break-inside: auto !important;
            break-inside: auto !important;
          }

          .tabela-historico th,
          .tabela-historico td {
            border: 1px solid #cbd5e0 !important;
            padding: 6px 8px !important;
            font-family: 'Montserrat', Arial, sans-serif !important;
            font-weight: 400 !important;
            text-align: center !important;
            vertical-align: middle !important;
            overflow-wrap: anywhere !important;
            word-break: break-word !important;
            color: #2d3748 !important;
            break-inside: avoid !important;
          }

          .tabela-historico .funcao-destaque {
            display: inline !important;
            margin: 0 !important;
            color: inherit !important;
            font-family: inherit !important;
            font-size: inherit !important;
            font-weight: inherit !important;
            line-height: inherit !important;
          }

          .tabela-historico th {
            background-color: #005516 !important;
            color: white !important;
            text-transform: uppercase !important;
            font-size: 8.5pt !important;
            font-weight: 700 !important;
          }

          .tabela-historico td {
            font-size: 8pt !important;
            font-weight: 400 !important;
          }

          .tabela-historico thead {
            display: table-header-group !important;
          }

          .tabela-historico tr,
          .tabela-historico td {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }

          .tabela-historico tbody tr:nth-child(odd) {
            background-color: #ffffff !important;
          }

          .tabela-historico tbody tr:nth-child(even) {
            background-color: #f2f7ff !important;
          }
      `
      document.head.appendChild(style)

      const nomeOriginal = this.membro?.nome || 'membro';
      const nomeArquivo = nomeOriginal
        .toLowerCase()
        .replace(/[\\/:*?"<>|]/g, '')
        .replace(/\s+/g, '_')
        .trim() || 'membro';

      const nomeArquivoFinal = `Membro_${nomeArquivo}.pdf`;

      const options = {
        margin: [35, 15, 15, 15],
        filename: `Membro_${nomeArquivo}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          scrollY: 0,
          scrollX: 0
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'landscape' },
        pagebreak: {
          mode: ['css'],
          avoid: '.tabela-historico tr'
        }
      }

      try {
        // 2. Renderiza o cabeçalho institucional em imagem
        const headerTemplate = this.$refs.cabecalhoPdf?.$refs?.headerBannerTemplate
        if (!headerTemplate) {
          throw new Error('Template de cabeçalho do PDF não foi encontrado.')
        }

        const canvasHeader = await html2canvas(headerTemplate, {
          useCORS: true,
          scale: 2,
          backgroundColor: '#f4f5f7',
          logging: false
        })
        const headerImgData = canvasHeader.toDataURL('image/png')

        // 3. Executa a conversão do html2pdf
        const pdfInstance = await html2pdf().set(options).from(container).toPdf().get('pdf')
        const totalPages = pdfInstance.internal.getNumberOfPages()

        const dataGeracao = format(new Date(), 'dd/MM/yyyy')

        // 4. Injeta o Cabeçalho e Rodapé em todas as páginas do PDF
        for (let i = 1; i <= totalPages; i++) {
          pdfInstance.setPage(i)
          
          pdfInstance.addImage(headerImgData, 'PNG', 15, 10, 267, 20)

          pdfInstance.setFontSize(8.5)
          pdfInstance.setTextColor(113, 128, 150)
          pdfInstance.text('Sistema de Colegiados – SISCOL', 15, 201)
          pdfInstance.text(String(i), 148.5, 201, { align: 'center' })
          pdfInstance.text(dataGeracao, 272, 201)
        }

        await pdfInstance.save(nomeArquivoFinal)
      } catch (erro) {
        console.error('Erro ao gerar PDF do membro:', erro)
        alert('Ocorreu um erro ao exportar o PDF do membro.')
      } finally {
        // 5. Remove elementos temporários
        if (document.head.contains(style)) {
          document.head.removeChild(style)
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/catalogoForm.scss";

.topo-header {
  border-bottom: none !important;
}
.caixa-form, .caixa-form-blocos {
  background-color: #ffffff !important;
  border: 1px solid #dde5e0 !important;
  box-shadow: 0 1px 2px #000, 0 10px 28px rgba(0, 0, 0, 0.1) !important;
}
.wrapper { background: transparent !important; }

* {
    margin: 0;
    padding: 0;
    font-family: 'Karla', sans-serif;
}

.filtro-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 1.5rem;
  gap: 0.5rem;
}

.filtro-label {
  font-family: "Montserrat-Bold", sans-serif;
  font-size: 0.9rem;
  color: #333;
  margin-right: 0.5rem;
}

.btn-filtro {
  background-color: #fff;
  border: 1px solid #ccc;
  color: #555;
  border-radius: 1.5rem;
  padding: 0.3rem 1.2rem;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-filtro:hover {
  border-color: #005516;
  color: #005516;
}

.btn-filtro.ativo {
  background-color: #005516;
  color: #fff;
  border-color: #005516;
  font-family: "Montserrat-Bold", sans-serif;
}

/*  BOTÕES DE AÇÃO NO TOPO */
/*  BOTÕES DE AÇÃO NO TOPO (PADRONIZADOS) */
.acoes-topo {
  display: flex;
  gap: 0.5rem;
  align-items: center;

  /* Classe base aplicada a todos os botões (Novo, Editar e Excluir) */
  .btn-acao {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    box-sizing: border-box;
    
    font-family: "Montserrat-Medium", sans-serif;
    font-size: 0.9rem;
    padding: 0.2rem 1rem;
    border-radius: 0.2rem;
    cursor: pointer;
    background: transparent;
    transition: 0.2s;
  }

  /* 1. Botão Novo Membro */
  .btn-novo {
    color: #005516;
    border: #005516 solid 0.15rem;

    &:hover {
      color: white;
      background-color: #005516;
    }
  }

  /* 2. Botão Editar */
  .btn-editar {
    color: #005516;
    border: #005516 solid 0.15rem;

    &:hover {
      color: white;
      background-color: #005516;
    }
  }

  /* 3. Botão Excluir */
  .btn-excluir {
    color: #d32f2f;
    border: #d32f2f solid 0.15rem;

    &:hover {
      color: white;
      background-color: #d32f2f;
    }
  }
}

.btn-baixar-pdf {
  color: #efefef;
  text-decoration: none;
  font-family: "Montserrat-Medium";
  border: #005516 solid 0.15rem;
  padding: 0.3rem 2rem;
  border-radius: 0.2rem;
  transition: 0.2s;
  background-color: #005516;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin: 0;
  line-height: 1.2;
  box-sizing: border-box;

  &:hover {
    color: white;
    background-color: #4CAF50;
  }
}


/*  NOVOS ESTILOS DO SISTEMA DE CARDS (GRID) */
.conteudo-cards {
  margin-top: 2rem; 
}
.painel-dados {
  display: grid;
  gap: 0.85rem;
  margin-top: 0rem;
}

.secao-dados {
  background: #fff;
  border: 1px solid #d9e2db;
  border-radius: 0.5rem;
  padding: 0.85rem 1rem 1rem;
  width: 100%;
  box-sizing: border-box;
}

.secao-titulo {
  margin: 0 0 0.75rem 0;
  padding: 0 0 0.4rem 0;
  border-bottom: 1px solid #e2eae4;
  font-family: "Montserrat-Bold", sans-serif;
  font-size: 0.98rem;
  color: #0a4a22;
  letter-spacing: 0.01em;
  text-transform: uppercase;
}

/* Grid padrão dos dados */
.grade-dados {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr)); 
  gap: 0.85rem 1rem;
}

.grade-dados-historico {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.item-dado {
  min-width: 0;
  padding: 0.4rem 0.6rem;
  background: #f7f9f7;
  border: 1px solid #e4ebe5;
  border-radius: 0.4rem;
}

.item-rotulo {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin: 0 0 0.15rem 0;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.96rem;
  line-height: 1.2;
  color: #005516;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.item-valor {
  display: block;
  font-family: "Montserrat-Medium", sans-serif;
  font-size: 0.9rem;
  line-height: 1.3;
  color: #1f1f1f;
  word-break: break-word;
  white-space: pre-wrap;
}

.item-dado--span2 { grid-column: span 2; }
.item-dado--largo { grid-column: 1 / -1; }

/* Espaçamento e visual entre múltiplos cards do histórico */
.cartao-historico {
  background: #fdfdfd; /* Cor de fundo bem clara para o card */
  border: 1px solid #005516; /* Borda fechada e sólida em todo o card */
  border-radius: 0.5rem; /* Bordas arredondadas */
  padding: 1rem; /* Espaçamento interno */
  margin-bottom: 1.2rem; /* Espaçamento externo entre os cards */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); /* Sombra suave para destacar */
}

/* Retira a regra que removia a borda do último elemento, já que agora são cards separados */
.cartao-historico:last-child {
  margin-bottom: 0;
}

.texto-aviso {
  color: #888;
  font-style: italic;
  margin: 1rem 0;
}

.so-pdf {
  display: none !important;
}

/*  ESTILOS DO MODAL DE EXCLUSÃO */
.modal-exclusao {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex; 
  align-items: center; 
  justify-content: center; 
  transition: opacity 0.3s ease;

  .modal-mask {
    border-radius: 1rem;
    position: relative;
    z-index: 1000;
    width: 60%; 
    max-height: 90vh; 
    background-color: #f2f2f2;
    display: flex; 
    flex-direction: column; 
  }

  .modal-container {
    padding: .7rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: "Montserrat-Medium", sans-serif;

    .modal-header h2 {
      font-size: 1.3rem;
      font-weight: bold;
      text-align: center;
      margin-top: 1rem;
      flex-shrink: 0; 
    }

    .modal-body {
      border: 1px solid gray;
      border-radius: 1rem;
      text-align: center;
      margin: 1rem;
      padding-bottom: 1rem;
      overflow-y: auto;
      flex-grow: 1;

      p {
        font-size: 1rem;
        font-weight: bold;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
        color: #005516;
      }

      .dados {
        text-align: left;
        margin-left: 1rem;
        padding-right: 1rem;
        
        .flexbox {
          display: grid;
          grid-template-columns: 1fr 1fr; 
          gap: 0.5rem 1.5rem; 
          margin-bottom: 0.5rem;
        }

        .texto-centralizado {
          font-weight: bold;
          font-size: 0.95rem;
          color: #000;
          word-break: break-word; 
        }

        span {
          font-weight: normal;
          font-size: 0.9rem;
          margin-left: 0.3rem;
          color: #333;
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: space-evenly;
      margin-bottom: 1rem;
      flex-shrink: 0;

      .btn-confirmar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #005516;
        color: #f2f2f2;
        cursor: pointer;
      }

      .btn-cancelar-exclusao {
        border: none;
        border-radius: .5rem;
        width: 30%;
        height: 2.2rem;
        background-color: #bd0000;
        color: #f2f2f2;
        cursor: pointer;
      }
    }
  }
}

/*  GERAL E RESPONSIVO */
.fora, 
.wrapper, 
.form, 
.form.centro, 
.topo-header {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

/* Espaçamento principal */
.fora {
  width: 100% !important; 
  max-width: 100% !important;  
  padding: 1.5rem 0 !important; 
  margin: 0 !important; 
  min-height: calc(100vh - 10rem);
}

.wrapper {
  padding: 1.5rem 0 !important; 
  margin: 0 auto !important;
  border: none !important;
}

/* Largura e centralização */
.form.centro,
.centro {
  width: 96vw !important;
  max-width: 96vw !important;
  margin: 0 auto !important;
  padding: 0 !important;
}

/* Alinhamento do cabeçalho */
.topo-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;

  h1 {
    font-family: "Montserrat-Medium";
    color: #ffa600;
    margin-left: 0.75rem;
    font-size: 1.8rem;
  }
}

/* AJUSTES PARA TELAS MENORES */
@media screen and (max-width: 1065px) {  
  .form.centro,
  .centro {
    width: 90vw !important;
    max-width: 90vw !important;
  }

  .topo-header {
    flex-direction: column;
    align-items: center;
    gap: 1rem;

    h1 {
      margin-left: 0;
      font-size: 1.5rem;
    }
  }

  .acoes-topo {
    flex-direction: column;
    width: 100%;
    
    .btn-novo-original, .btn-acao {
      width: 100%;
      justify-content: center;
    }
  }

  .grade-dados:not(.grade-dados-historico) {
    grid-template-columns: 1fr;
  }

  .grade-dados:not(.grade-dados-historico) .item-dado--span2 {
    grid-column: auto;
  }

  .modal-exclusao .modal-mask {
    width: 85%;
  }
}

@media screen and (max-width: 600px) {
  .modal-exclusao .modal-mask {
    width: 95%;
  }
  
  .modal-exclusao .modal-container .modal-body .dados .flexbox {
    grid-template-columns: 1fr;
    gap: 0.3rem;
  }
}

@media screen and (max-width: 600px) {
  .modal-exclusao .modal-mask {
    width: 95%;
  }
  
  .modal-exclusao .modal-container .modal-body .dados .flexbox {
    grid-template-columns: 1fr;
    gap: 0.3rem;
  }
}
</style>